import { render } from "./SettingsAdd.svg?vue&type=template&id=0765e7e0"
const script = {}
script.render = render

export default script